import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { upgradeRequest } from './actions'
import { selectUpgradeResponse } from './index'

export function useUpgradeSubscription() {
  const dispatch = useDispatch()

  const upgradeSubscription = useCallback((update) => {
    dispatch(upgradeRequest(update))
  }, [dispatch])

  const response = useSelector(selectUpgradeResponse)
  const { state, error } = response

  return {
    upgradeSubscription,
    state,
    error
  }
}

export default useUpgradeSubscription
